import { Button } from "components/ui/button";
import { AlertCircle } from "lucide-react";
import { IoRefresh } from "react-icons/io5";

interface QueryErrorCardProps {
  title: string;
  description: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

export const QueryErrorCard: React.FC<QueryErrorCardProps> = ({
  title,
  description,
  onRetry,
  isRetrying = false,
}) => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="bg-white p-8 rounded-lg border max-w-md w-full mx-4 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertCircle className="h-8 w-8 text-red-500" />
          </div>
        </div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{title}</h2>
        <p className="text-gray-600 mb-6">{description}</p>
        <Button
          onClick={onRetry}
          className="w-full bg-[#F5CB2B] hover:bg-[#e6bc1a] text-[#2B0C1A] font-semibold"
          disabled={isRetrying}
          isLoading={isRetrying}
        >
          <IoRefresh className={`mr-2 ${isRetrying ? "animate-spin" : ""}`} />
          Tentar novamente
        </Button>
        <p className="text-sm text-gray-500 mt-4">
          Se o problema persistir, entre em contato com o suporte.
        </p>
      </div>
    </div>
  );
};

export default QueryErrorCard;
